<template>
  <card>
    <list :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink" :cardLink="cardLink" :isUpdate="true"
      :isAdd="false" :itemLink="itemLink" :setLink="setLink" :openItem="true" :fields="fields" :searchDisable="true"
      @change="change" @changeFunction="changeFunction" :staticFilters="staticFilters" v-model="val" :filters="filters" />
  </card>
</template>
<script>
export default {
  name: "customers",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      val: [],
      staticFilters: [
        // {
        //   title: "Статус проверки",
        //   key: "done",
        //   default: null,
        //   items: [
        //     {
        //       id: null,
        //       key: "0",
        //       title: "Все задания",
        //     },
        //     {
        //       id: '1',
        //       key: 'checked_task',
        //       title: "Проверенные задания",
        //     },
        //     {
        //       id: '2',
        //       key: 'no_checked_task',
        //       title: "Не проверенные задания",
        //     },
        //   ],
        // },
      ],
      modalCreate: "customer",
      fields: [

      ],
      filters: [
        {
          key: "group",
          title: "Классы",
        },
        {
          key: "business_discipline",
          title: "Предметы",
        },
        {
          title: "Сезон",
          pushLink: `${process.env.HOST_URL}/api/v3/schools/${this.$store.state.business.id}/school_seasons`,
          single: false,
          key: "seasons",
          queryKey: "season",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_process",
      itemLink: "business/processes",
      setLink: "business/processes",
      columns: [
        // {
        //   key: "is_done",
        //   title: "Проверено",
        // },
        {
          key: "rate",
          title: "Оценка",
        },
        {
          key: "done_at",
          title: "Дата выполнения",
          dateTimeFormat: true
        },
        {
          key: "client",
          title: "Ученик",
          object: "full_name",
          disableLink: true
        },
        {
          key: "group",
          title: "Класс",
          object: "title",
          disableLink: true
        },
        {
          key: "work",
          title: "Задание",
          object: "title",
          disableLink: true
        },
        {
          key: "lessonplan",
          title: "Класс",
          object: "title",
          disableLink: true
        },
        {
          key: "discipline",
          title: "Класс",
          object: "title",
          disableLink: true
        },
        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>

</style>
